import {Steps} from 'shared/tools';

const STEPS = [
  {
    name: 'expenses.manage.policies.edit.steps.Policy Details',
    location: 'policy_details'
  },
  {
    name: 'expenses.manage.policies.edit.steps.Approvers',
    location: 'approvers'
  },
  {
    name: 'expenses.manage.policies.edit.steps.Employees',
    location: 'employees'
  },
  {
    name: 'expenses.manage.policies.edit.steps.Review',
    location: 'review'
  },
].map((s, i) => ({
  ...s,
  index: i + 1
}));

const singleton = new Steps(STEPS);

export default singleton;
